// extracted by mini-css-extract-plugin
module.exports = {"gameTags":"_a1dc2af","tag":"_3a0142a","text":"_f587da1","red":"_20a8b4e","purple":"_ed2d780","blue":"_e841113","lightGrey":"_42dfb06","green":"_b37182a"};